import { Routes, Route } from 'react-router-dom';
import { Button, Container, Stack, Title, Text } from '@mantine/core';

function Home() {
  return (
    <Container size="sm" py="xl">
      <Stack gap="md" align="center">
        <Title order={1}>Kloudwalker Web</Title>
        <Text c="dimmed">Vite + React + Mantine is set up and running.</Text>
        <Button onClick={() => alert('It works!')}>Get started</Button>
      </Stack>
    </Container>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
    </Routes>
  );
}
